import { css } from "@emotion/css"

import type { MassProductionSimulationResult } from "../../../../types/parsedResult"
import MASS_PRODUCTION_SIMULATION_RESULT from "../../../constant/massProductionSimulationResult"
import Column from "./Column"
import Head from "./Head"

type Props = { result: MassProductionSimulationResult | null; isLoading: boolean }

const Table = ({ result, isLoading }: Props) => {
  const normal = result?.normal ?? null
  const massProduction = result?.massProduction ?? null
  const repeatOrderCount = result?.repeatOrderCount ?? null

  return (
    <div className={styles.container}>
      <div>
        <Head repeatOrderCount={repeatOrderCount} />
      </div>
      <div className={styles.negativeMargin}>
        <Column
          title="ノーマルコース"
          result={normal}
          repeatOrderCount={repeatOrderCount}
          isLoading={isLoading}
          isCheaper={result?.type === MASS_PRODUCTION_SIMULATION_RESULT.NORMAL_COURSE_IS_CHEAPER}
        />
      </div>
      <div className={styles.negativeMargin}>
        <Column
          title="量産コース"
          result={massProduction}
          repeatOrderCount={repeatOrderCount}
          isLoading={isLoading}
          isCheaper={
            result?.type === MASS_PRODUCTION_SIMULATION_RESULT.MASS_PRODUCTION_COURSE_IS_CHEAPER ||
            result?.type === MASS_PRODUCTION_SIMULATION_RESULT.MASS_PRODUCTION_COURSE_IS_CHEAPER_IF_REPEAT
          }
        />
      </div>
    </div>
  )
}

export default Table

const styles = {
  container: css`
    display: flex;
  `,
  negativeMargin: css`
    margin-left: -1px;
  `,
}
